












import Component from 'vue-class-component'
import LoginContainer from '@/components/authentication/login-container/LoginContainer.component'
import {Prop} from 'vue-property-decorator'
import {PasswordType, PortalType, ResetPwdAuthenticationRequest} from '@payroll/optimus-common'
import {Action, Mutation} from 'vuex-class'
import FeedbackComponent from '../../base/FeedbackComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'

@Component({
    components: {
        LoginContainer
    }
})
export default class ResetPasswordComponent extends FeedbackComponent {

    @Prop() managingCompany!: string
    @Prop() resetPwToken!: string

    private resetPwdAuth: ResetPwdAuthenticationRequest = {} as ResetPwdAuthenticationRequest
    private tooltipMessage: string = ''
    private newPasswordRepeat: string = ''

    @Action('resetPassword', StoreNamespace.AUTHENTICATION) resetPassword: any
    @Mutation('setUserDetails', StoreNamespace.AUTHENTICATION) setUserDetails: any
    @Mutation('setTokens', StoreNamespace.AUTHORIZATION) setTokens: any

    mounted() {
        if (!this.managingCompany || !this.resetPwToken) {
            this.$router.push({name: 'not-found'})
        } else {
            this.resetPwdAuth.managingCompany = this.managingCompany
            this.resetPwdAuth.portalType = PortalType.BACKOFFICE
            this.resetPwdAuth.resetPwToken = this.resetPwToken
            this.tooltipMessage = ('' + this.$t('password_instructions_title'))
                + '</br>' + ('' + this.$t('password_instructions_text1'))
                + '</br>' + ('' + this.$t('password_instructions_text2'))
                + '</br>' + ('' + this.$t('password_instructions_text3'))
                + '</br>' + ('' + this.$t('password_instructions_text4'))
                + '</br>' + ('' + this.$t('password_instructions_text5'))
                + '</br>' + ('' + this.$t('password_instructions_text6'))
        }
    }

    onLogin() {
        if (this.resetPwdAuth.password === this.newPasswordRepeat) {
            this.resetPwdAuth.passwordType = PasswordType.PASSWORD
            this.resetPassword({requestBody: this.resetPwdAuth, requestorCallback: this})
        } else {
            this.serverErrorMessages.push(this.$t('passwords_not_matched').toString())
        }
    }

    onSuccess(data?: any, requestName?: string, message?: string): void {
        this.setUserDetails(data.userDetails)
        this.setTokens({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken
        })
        this.$router.push({name: 'lobby'})
    }
}
